var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useRef, useEffect, useMemo } from "react";
import FilterLabels from "@frameworks/web/components/generic/FilterLabels/FilterLabels";
var INITIAL_VISIBLE_FILTERS_LENGTH = 4;
var LEAST_SIZE_FOR_LAST_VISIBLE_TAG = 6;
var MAX_SIZE_FOR_LAST_VISIBLE_TAG = 20;
var VISIBLE_MINIMUM_ITEM = 1;
var FilterValues = function (props) {
    var removeFilter = props.removeFilter, filterLables = props.filterLables, toggleShowFilterTagsPopover = props.toggleShowFilterTagsPopover, setShowFilterTagsPopover = props.setShowFilterTagsPopover, showFilterTagsPopover = props.showFilterTagsPopover, setRemainingItemsLength = props.setRemainingItemsLength;
    var _a = __read(useState(INITIAL_VISIBLE_FILTERS_LENGTH), 2), visibleFiltersLength = _a[0], setVisibleFiltersLength = _a[1];
    var filtersTagMainRef = useRef(null);
    var filtersTagVisibleRef = useRef(null);
    var popoverRef = useRef(null);
    var buttonRef = useRef(null);
    var rearrangeTagsAsPerWidth = function () {
        var _a, _b;
        if (filtersTagMainRef.current && filtersTagVisibleRef.current) {
            var parentWidth = (_a = filtersTagMainRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
            var childWidth = (_b = filtersTagVisibleRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth;
            var updatedVisibleFiltersLength = visibleFiltersLength;
            if (childWidth >= parentWidth) {
                var childWidthParentWidthDifference = childWidth - parentWidth;
                if (childWidthParentWidthDifference < LEAST_SIZE_FOR_LAST_VISIBLE_TAG ||
                    childWidthParentWidthDifference > MAX_SIZE_FOR_LAST_VISIBLE_TAG) {
                    if (updatedVisibleFiltersLength - 2 >= VISIBLE_MINIMUM_ITEM)
                        updatedVisibleFiltersLength -= 2;
                }
                else {
                    if (updatedVisibleFiltersLength - 1 >= VISIBLE_MINIMUM_ITEM)
                        updatedVisibleFiltersLength -= 1;
                }
            }
            setVisibleFiltersLength(updatedVisibleFiltersLength);
        }
    };
    useEffect(function () {
        rearrangeTagsAsPerWidth();
    }, [filterLables]);
    useEffect(function () {
        var handleClickOutside = function (event) {
            var _a, _b;
            if (!((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) &&
                !((_b = buttonRef.current) === null || _b === void 0 ? void 0 : _b.contains(event.target))) {
                setShowFilterTagsPopover(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(function () {
        setRemainingItemsLength(filterLables.length - visibleFiltersLength);
    }, [visibleFiltersLength, filterLables]);
    var updatedVisibleItems = useMemo(function () { return filterLables.slice(0, visibleFiltersLength); }, [visibleFiltersLength, filterLables]);
    return (React.createElement("div", { className: "d-flex filters-tag-main text-nowrap justify-content-between".concat(showFilterTagsPopover ? " w-400" : ""), ref: filtersTagMainRef },
        React.createElement("div", { ref: filtersTagVisibleRef, className: "filters-tag-visible position-relative" }, showFilterTagsPopover ? (React.createElement("div", { id: "popup", ref: popoverRef, className: "popup filters-tag-popup d-flex flex-row text-wrap ".concat(!showFilterTagsPopover ? "d-none" : "") },
            React.createElement("div", { className: "filters-tag-popup-content d-flex" },
                React.createElement("div", { className: "px-1" }, filterLables.map(function (filterObj) { return (React.createElement(FilterLabels, { LabelText: filterObj.title, closeBtn: !filterObj.disable, key: "".concat(filterObj.keyName, "-").concat(filterObj.subKeyName), FilterAction: function () {
                        filterObj.disable
                            ? function () { }
                            : removeFilter(filterObj.keyName, filterObj.subKeyName);
                    } })); })),
                React.createElement("div", { className: "bg_white DMSanN_12_400 filters-tag-close-btn hand_cursor flex-nowrap text-decoration-underline" },
                    React.createElement("a", { onClick: toggleShowFilterTagsPopover, className: "btn-text" }, "Close"))))) : (updatedVisibleItems.map(function (filterObj) { return (React.createElement(FilterLabels, { LabelText: filterObj.title, closeBtn: !filterObj.disable, key: "".concat(filterObj.keyName, "-").concat(filterObj.subKeyName), FilterAction: function () {
                filterObj.disable
                    ? function () { }
                    : removeFilter(filterObj.keyName, filterObj.subKeyName);
            } })); })))));
};
export default FilterValues;
